import { useEffect } from 'react';
import { FaExclamationCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';
import style from './style.module.css';

const CustomAlert = ({ message, type, onClose }) => {
    const getVariant = () => {
        switch (type) {
            case 'xəta':
                return 'error';
            case 'xəbərdarlıq':
                return 'warning';
            case 'məlumat':
                return 'info';
            default:
                return type;
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);

        return () => clearTimeout(timer);
    }, [onClose]);

    const icons = {
        error: <FaExclamationCircle />,
        warning: <FaExclamationTriangle />,
        info: <FaInfoCircle />
    };

    const variant = getVariant();

    return (
        <div className={style['custom-alert']}>
            <div className={`${style['alert-content']} ${style[variant]}`}>
                <span className={style.icon}>
                    {icons[variant]}
                </span>
                <p>{message}</p>
                <button className={style['close-btn']} onClick={onClose}>&times;</button>
            </div>
        </div>
    );
};

export default CustomAlert;